var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pcg-btn',{staticClass:"mr-4 prk-button",attrs:{"round":"","icon":_vm.iconRemove,"text":"delete","variant":"danger"},on:{"click":_vm.removePath}})}
var staticRenderFns = []

export { render, staticRenderFns }